export default "__VITE_ASSET__CZReZz7w__"